import { useState, useCallback } from 'react';

interface ProgressiveImageProps {
  thumbnailUrl: string;
  fullUrl: string;
  alt: string;
  className?: string;
  onClick?: () => void;
}

export function ProgressiveImage({ thumbnailUrl, fullUrl, alt, className, onClick }: ProgressiveImageProps) {
  const [isLoaded, setIsLoaded] = useState(false);

  const handleLoad = useCallback(() => {
    setIsLoaded(true);
  }, []);

  return (
    <button
      onClick={onClick}
      className={`relative block overflow-hidden ${className ?? ''}`}
      type="button"
    >
      {/* Blurred thumbnail */}
      <img
        src={thumbnailUrl}
        alt=""
        aria-hidden="true"
        loading="lazy"
        decoding="async"
        className="h-full w-full object-cover"
        style={{
          filter: isLoaded ? 'blur(0)' : 'blur(10px)',
          transform: isLoaded ? 'none' : 'scale(1.05)',
          transition: 'filter 0.4s ease-out, transform 0.4s ease-out',
        }}
      />
      {/* Full resolution image */}
      <img
        src={fullUrl}
        alt={alt}
        onLoad={handleLoad}
        loading="lazy"
        decoding="async"
        className="absolute inset-0 h-full w-full object-cover"
        style={{
          opacity: isLoaded ? 1 : 0,
          transition: 'opacity 0.4s ease-out',
        }}
      />
    </button>
  );
}
